import React from "react";

const Header = ({ schoolData, clubData }) => {
    return (
        <div className="header">
            <div className="header-left">
                {/* ✅ School Logo & Name */}
                {schoolData?.logo && (
                    <img src={schoolData.logo} alt={schoolData.name} className="school-logo" />
                )}
                <div className="school-info">
                    <h1 className="school-name">{schoolData?.name}</h1>
                    <h2 className="club-name">{clubData?.name}</h2>
                </div>
            </div>

            {/* ✅ Club Logo on the right */}
            {clubData?.logo && (
                <img src={clubData.logo} alt={clubData.name} className="club-logo" />
            )}
        </div>
    );
};

export default Header;
